module.exports = __webpack_public_path__ + "assets/0eff9865ed5334acf095aadd399e5e02.svg";